import React from "react";
import PropTypes from "prop-types";

const ReportPageAction = ({ subheading }) => {
  return (
    <div className="row mb-2 mx-0">
      <div className="col-12 sales-page-title-wrap sub-heading-blog-wrap pb-2">
        <div className="row box-heading">
          <div className="col-md-4 d-flex flex-wrap align-items-center">
            <h2>{subheading}</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

ReportPageAction.propTypes = {
  subheading: PropTypes.string.isRequired
};

export default ReportPageAction;
